var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M7 .969C3.254.969.219 4.03.219 7.75A6.78 6.78 0 0 0 7 14.531c3.719 0 6.781-3.035 6.781-6.781C13.781 4.031 10.72.969 7 .969m0 3.008c.629 0 1.148.52 1.148 1.148 0 .656-.52 1.148-1.148 1.148a1.12 1.12 0 0 1-1.148-1.148c0-.629.492-1.148 1.148-1.148m1.531 6.945a.33.33 0 0 1-.328.328H5.797a.316.316 0 0 1-.328-.328v-.656c0-.164.136-.328.328-.328h.328v-1.75h-.328a.316.316 0 0 1-.328-.329v-.656c0-.164.136-.328.328-.328h1.75c.164 0 .328.164.328.328v2.734h.328c.164 0 .328.165.328.329z"
  })));
};
export default SvgInfo;